import reducer from './module';
import { name, types } from './actionTypes';

// Export specific items instead of everything
export { actions, selectors } from './module';
export type { DocumentById } from './types';
export { types };
export default { name, reducer };
